import { PagedSearch } from '../../../shared/model/index';
import { EcomPriceOperatorEnum } from './ecom-price-operator-enums.enum';

export class EcomSearch extends PagedSearch {
  public CategoryId: number;
  public Title: string;
  public Price: number;
  public PriceOperator: EcomPriceOperatorEnum;
  public MemberPrice: number;
  public MemberPriceOperator: EcomPriceOperatorEnum;
  public ItemNum: number;
  public ItemTypeId: number;
  public ItemIds: number[];
  public Inactive: boolean = false;
}
